import useUploadImage from "@babackapp/private-api-client/client/use-upload-image";
import { useCurrentShopSuspense } from "../shops/use-current-shop-suspense";

export default function useUploadShopLogo() {
	const { data: shop } = useCurrentShopSuspense();
	return useUploadImage(shop.id, "/shops/{shopId}/logo");
}
